import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { formatISO } from 'lib/dates'

import {
  getIsFetchingConfirmation,
  getStep,
  getDatesAndPaxes,
} from 'src/effects/ModifyDates/selectors'

import {
  modifyDatesConfirmationRequestAction,
  modifyDatesBackToSelectOfferAction,
} from 'src/effects/ModifyDates/actions'

import ButtonSimple from 'src/comps/ButtonSimple'
import IconInfo from 'client/icons/Info'
import InformationBox from 'src/comps/InformationBox'
import DatesChangeConnected from 'src/comps/DatesChangeConnected'
import ModifyDatesDetails from 'src/comps/ModifyDates/ModifyDatesDetails'
import ModifyDatesRoom from 'src/comps/ModifyDates/ModifyDatesRoom'

import { ConfirmOfferBase, Title, Content, ButtonWrapper, DetailsWrapper } from './styles'
import messages from './messages'
import { Button } from '@s4l/ds'
import { IconArrowLeft } from '@s4l/icons/IconArrowLeft'

const ConfirmOffer = ({ board, hash, existingBooking }) => {
  const intl = useIntl()
  const dispatch = useDispatch()

  const isFetching = useSelector(getIsFetchingConfirmation)
  const { checkIn: checkInISO, checkOut: checkOutISO } = useSelector(getDatesAndPaxes)
  const step = useSelector(getStep)

  const checkIn = formatISO(checkInISO)
  const checkOut = formatISO(checkOutISO)

  const newBooking = {
    checkIn,
    checkOut,
    adults: board?.adults,
    children: board?.children,
  }

  function handleBack() {
    dispatch(modifyDatesBackToSelectOfferAction())
  }

  function handleConfirmation() {
    dispatch(modifyDatesConfirmationRequestAction({ hash, availabilityId: board.availabilityId }))
  }

  return (
    <ConfirmOfferBase>
      <Content>
        <Title>
          <FormattedMessage {...messages.confirmOffer} />
        </Title>

        <Button
          onClick={handleBack}
          variant="text-flat"
          size="small"
          leadingIcon={<IconArrowLeft />}
          className="mb-16"
        >
          {intl.formatMessage(messages.back)}
        </Button>

        <DetailsWrapper>
          <ModifyDatesDetails
            booking={existingBooking}
            newBooking={newBooking}
            title="change-dates.new-dates-title"
            border
          />
          <ModifyDatesRoom
            room={board}
            existingBooking={existingBooking}
            offerSelected
            isMultiroom={false}
          />
        </DetailsWrapper>

        <InformationBox
          icon={<IconInfo />}
          text={intl.formatMessage(messages.importantInformation)}
          title={intl.formatMessage(messages.importantInformationTitle)}
        />
      </Content>

      <DatesChangeConnected
        trackingData={{
          context: 'booking_thanks',
          details: 'Confirm offer',
        }}
      >
        <ButtonWrapper>
          <ButtonSimple
            dataTestId="confirm-offer-btn"
            fullWidth
            isLoading={isFetching || step === null}
            onClick={handleConfirmation}
            text={intl.formatMessage(messages.confirm)}
            variant="primary"
          />
        </ButtonWrapper>
      </DatesChangeConnected>
    </ConfirmOfferBase>
  )
}

ConfirmOffer.propTypes = {
  board: PropTypes.instanceOf(Object),
  hash: PropTypes.string.isRequired,
  existingBooking: PropTypes.instanceOf(Object),
}

export default ConfirmOffer
